import styled from "styled-components";

export const StyledSitePopup = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1500;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: clamp(14px, 3.5vw, 32px);
  background: rgba(2, 8, 12, 0.72);
  backdrop-filter: blur(5px);
  animation: site-popup-overlay-in 0.18s ease-out both;

  &.is-closing {
    animation: site-popup-overlay-out 0.18s ease-in both;
  }

  .site-popup-card {
    position: relative;
    display: flex;
    flex-direction: column;
    width: min(378px, calc(100vw - 28px), calc((100dvh - 116px) * 0.63));
    max-width: calc(100vw - 28px);
    max-height: calc(100dvh - 28px);
    border: 1px solid rgba(89, 244, 119, 0.2);
    border-radius: 16px;
    background: #0b2028;
    box-shadow:
      0 24px 70px rgba(0, 0, 0, 0.46),
      inset 0 1px 0 rgba(255, 255, 255, 0.05);
    overflow: hidden;
    animation: site-popup-card-in 0.24s cubic-bezier(0.2, 0.9, 0.2, 1.05) both;
  }

  &.is-closing .site-popup-card {
    animation: site-popup-card-out 0.18s ease-in both;
  }

  .site-popup-card.is-text {
    width: min(520px, calc(100vw - 28px));
  }

  .site-popup-media {
    position: relative;
    width: 100%;
    background: #06151b;
  }

  .site-popup-figure {
    width: 100%;
    aspect-ratio: 378 / 600;
    margin: 0;
    background: #06151b;
    overflow: hidden;
  }

  .site-popup-figure img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    background: #06151b;
  }

  .site-popup-arrow {
    position: absolute;
    top: 50%;
    z-index: 3;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 42px;
    height: 54px;
    border: 1px solid rgba(255, 255, 255, 0.14);
    border-radius: 14px;
    color: #ffffff;
    background: rgba(3, 12, 17, 0.56);
    box-shadow: 0 10px 28px rgba(0, 0, 0, 0.28);
    backdrop-filter: blur(6px);
    cursor: pointer;
    transform: translateY(-50%);
    transition:
      background 0.15s ease,
      border-color 0.15s ease,
      transform 0.15s ease,
      opacity 0.15s ease;
  }

  .site-popup-arrow:hover {
    border-color: rgba(89, 244, 119, 0.42);
    background: rgba(9, 28, 34, 0.82);
    transform: translateY(-50%) scale(1.03);
  }

  .site-popup-arrow span {
    display: block;
    transform: translateY(-2px);
    font-size: 38px;
    font-weight: 800;
    line-height: 1;
  }

  .site-popup-arrow.is-prev {
    left: 10px;
  }

  .site-popup-arrow.is-next {
    right: 10px;
  }

  .site-popup-text-panel {
    width: min(520px, calc(100vw - 28px));
    max-height: calc(100dvh - 116px);
    padding: 28px;
    color: #d5e0e9;
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: rgba(89, 244, 119, 0.7) rgba(5, 14, 20, 0.35);
  }

  .site-popup-text-panel::-webkit-scrollbar {
    width: 5px;
  }

  .site-popup-text-panel::-webkit-scrollbar-track {
    background: rgba(5, 14, 20, 0.35);
    border-radius: 999px;
  }

  .site-popup-text-panel::-webkit-scrollbar-thumb {
    background: rgba(89, 244, 119, 0.7);
    border-radius: 999px;
  }

  .site-popup-text-panel h2 {
    margin: 0 38px 16px 0;
    color: #ffffff;
    font-size: 23px;
    line-height: 1.25;
    font-weight: 800;
  }

  .site-popup-html {
    color: #c0ced9;
    font-size: 15px;
    line-height: 1.6;
    word-break: keep-all;
    overflow-wrap: anywhere;
  }

  .site-popup-html p {
    margin: 0 0 12px;
  }

  .site-popup-footer {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    min-height: 58px;
    padding: 10px 12px;
    border-top: 1px solid rgba(255, 255, 255, 0.06);
    background: #0d242d;
  }

  .site-popup-actions {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
    min-width: 0;
  }

  .site-popup-actions button {
    height: 38px;
    border: 0;
    border-radius: 9px;
    padding: 0 14px;
    font-size: 13px;
    font-weight: 800;
    white-space: nowrap;
    cursor: pointer;
    transition:
      filter 0.15s ease,
      transform 0.15s ease,
      background 0.15s ease,
      color 0.15s ease;
  }

  .site-popup-actions button:hover {
    transform: translateY(-1px);
  }

  .site-popup-secondary {
    color: #d5e0e9;
    background: rgba(255, 255, 255, 0.07);
  }

  .site-popup-secondary:hover {
    background: rgba(255, 255, 255, 0.1);
  }

  .site-popup-primary {
    color: #06140f;
    background: var(--crypto-green, #3ef26d);
    box-shadow: 0 10px 22px rgba(63, 242, 110, 0.16);
  }

  .site-popup-primary:hover {
    filter: brightness(1.04);
  }

  .site-popup-dots {
    display: flex;
    justify-content: center;
    gap: 7px;
    padding: 9px 12px 12px;
    background: #0d242d;
  }

  .site-popup-dots button {
    width: 7px;
    height: 7px;
    border: 0;
    border-radius: 999px;
    padding: 0;
    background: rgba(213, 224, 233, 0.32);
    cursor: pointer;
    transition:
      width 0.16s ease,
      background 0.16s ease;
  }

  .site-popup-dots button.active {
    width: 20px;
    background: var(--crypto-green, #3ef26d);
  }

  @media (max-width: 575px) {
    align-items: center;
    padding: 12px;

    .site-popup-card {
      width: min(378px, calc(100vw - 24px), calc((100dvh - 116px) * 0.63));
      border-radius: 14px;
    }

    .site-popup-arrow {
      width: 34px;
      height: 46px;
      border-radius: 12px;
    }

    .site-popup-arrow.is-prev {
      left: 7px;
    }

    .site-popup-arrow.is-next {
      right: 7px;
    }

    .site-popup-arrow span {
      font-size: 32px;
    }

    .site-popup-footer {
      min-height: 54px;
      padding: 8px;
      gap: 8px;
    }

    .site-popup-actions {
      gap: 6px;
    }

    .site-popup-actions button {
      height: 36px;
      border-radius: 8px;
      padding: 0 10px;
      font-size: 12px;
    }

    .site-popup-text-panel {
      max-height: calc(100dvh - 112px);
      padding: 22px;
    }
  }

  @keyframes site-popup-overlay-in {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes site-popup-overlay-out {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }

  @keyframes site-popup-card-in {
    from {
      opacity: 0;
      transform: translateY(18px) scale(0.97);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }

  @keyframes site-popup-card-out {
    from {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
    to {
      opacity: 0;
      transform: translateY(10px) scale(0.98);
    }
  }
`;
